module.exports = __webpack_public_path__ + "img/d2.12642b1c.png";